var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 2,
    y: 2,
    fill: "#DBE9FF",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4887E8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M19.333 11.514v2.753c0 .374 0 .56.073.703a.667.667 0 0 0 .291.291c.143.073.33.073.703.073h2.754m.18 1.326v4.807c0 1.12 0 1.68-.219 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218h-4.266c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.427-.218-.988-.218-2.108v-6.933c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.428-.218.987-.218 2.108-.218h2.14c.49 0 .735 0 .965.055a2 2 0 0 1 .578.24c.202.123.375.296.72.642l2.126 2.126c.346.346.519.519.643.72.11.18.19.374.239.578.055.23.055.475.055.965Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 2,
    y: 2,
    stroke: "#F2F4F8",
    strokeWidth: 4,
    rx: 16
  })));
};
export default SvgFile;